var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.125C3.65117 0.125 0.125 3.65117 0.125 8C0.125 12.3488 3.65117 15.875 8 15.875C12.3488 15.875 15.875 12.3488 15.875 8C15.875 3.65117 12.3488 0.125 8 0.125ZM8 14.5391C4.38945 14.5391 1.46094 11.6105 1.46094 8C1.46094 6.43555 2.01113 4.99766 2.92871 3.87266L12.1273 13.0713C11.0023 13.9889 9.56445 14.5391 8 14.5391ZM13.0713 12.1273L3.87266 2.92871C4.99766 2.01113 6.43555 1.46094 8 1.46094C11.6105 1.46094 14.5391 4.38945 14.5391 8C14.5391 9.56445 13.9889 11.0023 13.0713 12.1273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.84b7e58b5292531500e54a279c354fba.svg";
export { ForwardRef as ReactComponent };